import { ZodError } from 'zod/v4';

export class ResponseSchemaError<Data> extends ZodError {
    name = 'ResponseSchemaError';
    data?: Data;
    url: string;

    constructor({ cause, data, url }: { cause: ZodError; data?: Data; url: string }) {
        super(cause.issues);
        this.name = 'ResponseSchemaError';
        this.data = data;
        this.url = url;
        this.cause = cause;
        this.stack = cause.stack;
    }
}
